var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTask = function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "task_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.95 18 5.65-5.65-1.45-1.45-4.225 4.225-2.1-2.1L7.4 14.45zM4 22V2h10l6 6v14zm9-13V4H6v16h12V9zM6 4v5zv16z"
  })));
};
export { SvgTask as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTAuOTUgMThMMTYuNiAxMi4zNUwxNS4xNSAxMC45TDEwLjkyNSAxNS4xMjVMOC44MjUgMTMuMDI1TDcuNCAxNC40NUwxMC45NSAxOFpNNCAyMlYySDE0TDIwIDhWMjJINFpNMTMgOVY0SDZWMjBIMThWOUgxM1pNNiA0VjlWNFY5VjIwVjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";